import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  alpha,
} from '@mui/material';
import { motion } from 'framer-motion';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PublicIcon from '@mui/icons-material/Public';
import WidgetsIcon from '@mui/icons-material/Widgets';
import CategoryIcon from '@mui/icons-material/Category';
import EditNoteIcon from '@mui/icons-material/EditNote';

export default function ProjectActivityHowItWorks() {
  return (
    <Box sx={{ py: { xs: 1, md: 14 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">

        {/* BAŞLIK */}
        <Box textAlign="center" mb={{ xs: 6, md: 10 }}>
          <Chip
            label="NASIL ÇALIŞIR?"
            size="small"
            sx={{
              mb: 2,
              backgroundColor: alpha('#2563eb', 0.12),
              color: '#2563eb',
              fontWeight: 700,
              fontSize: '0.75rem',
              letterSpacing: '0.8px',
              height: 32,
              px: 2,
              borderRadius: 2,
            }}
          />

          <Typography
            variant="h3" fontWeight={700} mb={2} color="#0f172a"
          >
            Proje ve Faaliyet Yapısı
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{ color: 'text.secondary', fontSize: '1.1rem' }}
          >
            Projeler bağış ve fon yönetimi için, faaliyetler ise içerik ve web yayını
            için tasarlanmıştır.
            <br/>
             İki yapı paralel ve kontrollü şekilde ilerler.
          </Typography>
        </Box>

        <Grid container spacing={4}>

          {/* PROJE AKIŞI */}
          <Grid item xs={12} md={6}>
            <motion.div
            >
              <FlowColumn
                title="Proje Akışı"
                subtitle="Bağış ve fon odaklı yapı"
                color="#2563eb"
                steps={[
                  {
                    icon: <AccountTreeIcon />,
                    title: 'Proje Oluşturma',
                    desc: 'Amaç, hedef bütçe ve proje süresi tanımlanır.'
                  },
                  {
                    icon: <VolunteerActivismIcon />,
                    title: 'Bağışların Bağlanması',
                    desc: 'Yapılan bağışlar otomatik olarak ilgili projeye kaydedilir.'
                  },
                  {
                    icon: <PublicIcon />,
                    title: 'Web Sitesinde Yayın',
                    desc: 'Proje detayları ve bağış durumu web sitesinde gösterilir.'
                  },
                  {
                    icon: <WidgetsIcon />,
                    title: 'Widget Kullanımı',
                    desc: "Projeler widget/'lar ile farklı alanlarda sunulabilir."
                  }
                ]}
                note="Projeler bağış süreçleri ile ilişkilidir."
              />
            </motion.div>
          </Grid>

          {/* FAALİYET AKIŞI */}
          <Grid item xs={12} md={6}>
            <motion.div
            >
              <FlowColumn
                title="Faaliyet Akışı"
                subtitle="İçerik ve yayın odaklı yapı"
                color="#10b981"
                steps={[
                  {
                    icon: <CategoryIcon />,
                    title: 'Faaliyet Kategorileri',
                    desc: 'Yemek, barınma, eğitim gibi alanlar tanımlanır.'
                  },
                  {
                    icon: <EditNoteIcon />,
                    title: 'Faaliyet İçeriği',
                    desc: 'Metin, görsel ve detay bilgileri girilir.'
                  },
                  {
                    icon: <PublicIcon />,
                    title: 'Web Sitesinde Yayın',
                    desc: 'Faaliyetler sayfa veya liste olarak yayınlanır.'
                  },
                  {
                    icon: <WidgetsIcon />,
                    title: 'Widget Entegrasyonu',
                    desc: "Faaliyet içerikleri widget/'lar ile kullanılır."
                  }
                ]}
                note="Faaliyetler bağıştan bağımsızdır."
              />
            </motion.div>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

/* AKIŞ SÜTUNU */
function FlowColumn({ title, subtitle, steps, color, note }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        height: '100%',
        borderRadius: 3,
        border: '2px solid #e5e7eb',
        background: '#ffffff',
        transition: 'all 0.4s ease',
        '&:hover': {
          borderColor: color,
          boxShadow: `0 12px 30px ${alpha(color, 0.12)}`,
          transform: 'translateY(-4px)',
        }
      }}
    >
      <Typography
        fontWeight={800}
        sx={{
          fontSize: '1.4rem',
          mb: 0.5,
          color: '#0f172a'
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: '#64748b',
          mb: 4,
          fontSize: '0.95rem',
          fontWeight: 500
        }}
      >
        {subtitle}
      </Typography>

      {steps.map((step, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            gap: 2.5,
            mb: i === steps.length - 1 ? 0 : 3.5,
            position: 'relative'
          }}
        >
          {/* Çizgi */}
          {i !== steps.length - 1 && (
            <Box
              sx={{
                position: 'absolute',
                left: 19,
                top: 48,
                width: 2,
                height: 'calc(100% + 14px)',
                background: `linear-gradient(180deg, ${alpha(color, 0.3)} 0%, ${alpha(color, 0.1)} 100%)`,
              }}
            />
          )}

          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${alpha(color, 0.2)} 0%, ${alpha(color, 0.1)} 100%)`,
              color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              border: `2px solid ${alpha(color, 0.3)}`,
              position: 'relative',
              zIndex: 1,
            }}
          >
            {step.icon}
          </Box>

          <Box>
            <Typography
              fontWeight={700}
              sx={{
                color: '#0f172a',
                fontSize: '1.05rem',
                mb: 0.5
              }}
            >
              {step.title}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.9rem',
                color: '#64748b',
                lineHeight: 1.6
              }}
            >
              {step.desc}
            </Typography>
          </Box>
        </Box>
      ))}

      <Box
        sx={{
          mt: 4,
          p: 1,
          borderRadius: 2,
          background: `linear-gradient(135deg, ${alpha(color, 0.12)} 0%, ${alpha(color, 0.08)} 100%)`,
          border: `1.5px solid ${alpha(color, 0.25)}`,
          color,
          fontWeight: 600,
          textAlign: 'center',
          fontSize: '0.95rem'
        }}
      >
        {note}
      </Box>
    </Paper>
  );
}
